// src/components/roles/RoleWizard/RoleWizard.styles.ts
import { styled } from '@mui/material/styles';
import { Drawer, Box, Button } from '@mui/material';

export const StyledDrawer = styled(Drawer)(({ theme }) => ({
  '& .MuiDrawer-paper': {
    width: '800px',
    maxWidth: '90vw',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      maxWidth: '100vw',
    },
  },
}));

export const DrawerContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
});

export const DrawerHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: theme.spacing(3),
  borderBottom: '1px solid',
  borderColor: theme.palette.divider,
}));

export const DrawerTitle = styled(Box)(({ theme }) => ({
  fontSize: '1.25rem',
  fontWeight: 600,
  color: theme.palette.text.primary,
}));

export const CloseButton = styled(Button)(({ theme }) => ({
  minWidth: 'auto',
  width: 40,
  height: 40,
  padding: 0,
  borderRadius: '50%',
  color: theme.palette.text.secondary,
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
}));

export const DrawerContent = styled(Box)(({ theme }) => ({
  flex: 1,
  overflowY: 'auto',
  padding: theme.spacing(3),
}));

export const DrawerFooter = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: theme.spacing(3),
  borderTop: '1px solid',
  borderColor: theme.palette.divider,
  gap: theme.spacing(2),
}));

export const CancelButton = styled(Button)(({ theme }) => ({
  minWidth: 120,
  borderColor: theme.palette.divider,
  color: theme.palette.text.secondary,
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
    borderColor: theme.palette.divider,
  },
}));

export const NextButton = styled(Button)({
  minWidth: 120,
  background: 'linear-gradient(to right, #06b6d4, #10b981)',
  color: 'white',
  '&:hover': {
    background: 'linear-gradient(to right, #0891b2, #059669)',
  },
  '&:disabled': {
    background: '#e5e7eb',
    color: '#9ca3af',
  },
});

export const BackButton = styled(Button)(({ theme }) => ({
  minWidth: 120,
  borderColor: theme.palette.divider,
  color: theme.palette.text.secondary,
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
    borderColor: theme.palette.divider,
  },
}));

export const SaveButton = styled(Button)({
  minWidth: 120,
  background: 'linear-gradient(to right, #06b6d4, #10b981)',
  color: 'white',
  '&:hover': {
    background: 'linear-gradient(to right, #0891b2, #059669)',
  },
  '&:disabled': {
    background: '#e5e7eb',
    color: '#9ca3af',
  },
});
